// Build-time version info, injected by vite.config.ts.
// APP_VERSION is sourced from web/package.json — bump the patch number
// every time we ship bug fixes (see .claude/CLAUDE.md).
export const APP_VERSION: string = __APP_VERSION__;
export const GIT_SHA: string = __GIT_SHA__;
